import { render } from "./ProductosPrecioView.vue?vue&type=template&id=924408b0&scoped=true"
import script from "./ProductosPrecioView.vue?vue&type=script&lang=js"
export * from "./ProductosPrecioView.vue?vue&type=script&lang=js"

import "./ProductosPrecioView.vue?vue&type=style&index=0&id=924408b0&scoped=true&lang=css"
import "./ProductosPrecioView.vue?vue&type=style&index=1&id=924408b0&scoped=true&lang=css"
import "./ProductosPrecioView.vue?vue&type=style&index=2&id=924408b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924408b0"]])

export default __exports__